import { useEffect, useState } from "react";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Steps } from "@/components/site/Steps";
import { Pricing } from "@/components/site/Pricing";
import { Ritual } from "@/components/site/Ritual";
import { Footer } from "@/components/site/Footer";
import { CheckoutDialog } from "@/components/site/CheckoutDialog";
import { DailyCard } from "@/components/site/DailyCard";
import { ChatWidget } from "@/components/site/ChatWidget";

export default function Home() {
  const [open, setOpen] = useState(false);
  const [plan, setPlan] = useState(null);
  const book = (id) => { setPlan(id || null); setOpen(true); };

  useEffect(() => {
    if (open) window.__lenis?.stop(); else window.__lenis?.start();
  }, [open]);

  return (
    <SmoothScroll>
      <Header onBook={book} />
      <main>
        <Hero onBook={book} />
        <Marquee />
        <DailyCard onBook={book} />
        <Steps />
        <Pricing onBook={book} />
        <Ritual onBook={book} />
      </main>
      <Footer onBook={book} />
      <CheckoutDialog open={open} onOpenChange={setOpen} planId={plan} />
      <ChatWidget />
    </SmoothScroll>
  );
}
